import BaseService from './baseService';

export default class extends BaseService {
    constructor() {
        super("settings");
    }

    getFeaturesConfiguration = () => this.httpGetRequest(`featuresConfiguration`);
}